import { useState, useEffect } from 'react';

/**
 * Stabilizes a boolean by immediately setting to true but delaying clearing to false.
 * Prevents UI flickering during rapid state changes (e.g. CopilotKit loading states).
 */
export const useStabilized = (value: boolean) => {
  const [stable, setStable] = useState(value);
  useEffect(() => {
    if (value) {
      setStable(true);
    } else {
      const timer = setTimeout(() => setStable(false), 300);
      return () => clearTimeout(timer);
    }
  }, [value]);
  return stable;
};
